import TyreBarcodeScannerBaseController from "./tyre_barcode_scanner_base_controller"

export default class extends TyreBarcodeScannerBaseController {
  static values = {
    ...TyreBarcodeScannerBaseController.values,
    garageItemSelected: Boolean,
    itemSelectedStatus: String,
    itemAlreadySelectedStatus: String,
  }

  connect() {
    super.connect()

    if (this.garageItemSelectedValue === true) {
      this.showStatus(this.itemSelectedStatusValue, true)
    }
  }

  submitBarcode(event) {
    let fromScan = true
    if (event) {
      event.preventDefault()
      fromScan = false
    }

    const scannedBarcode = this.normalizedValue(this.inputTarget.value)
    if (!scannedBarcode) {
      return
    }

    const existingGarageItem = this.findMatchingGarageItem(scannedBarcode)
    const alreadySelected = existingGarageItem && existingGarageItem.dataset.garageSelectionIsSelected === "true"

    if (existingGarageItem) {
      if (alreadySelected) {
        this.showStatus(this.itemAlreadySelectedStatusValue, true)
        this.resetAfterAlreadySelected()
        return
      } else {
        this.selectGarageItem(existingGarageItem)
        return
      }
    }

    this.openAddNewGarageItemModal(scannedBarcode, fromScan)
  }

  findMatchingGarageItem(scannedBarcode) {
    const list = document.querySelector("#garage_items_list")
    if (!list) {
      return null
    }

    const items = list.querySelectorAll("[data-garage-selection-item]")

    return Array.from(items).find((item) => this.normalizedValue(item.dataset.garageSelectionBarcode) === scannedBarcode)
  }

  async selectGarageItem(garageItemElement) {
    const selectButton = garageItemElement.querySelector("#garage_item_select_button_" + garageItemElement.dataset.garageSelectionItem)
    if (!selectButton || selectButton.hasAttribute("disabled")) {
      return
    }
    const url = new URL(selectButton.href, window.location.origin)
    url.searchParams.set("garage_item_selected", "true")

    selectButton.href = url.toString()
    selectButton.click()
  }

  resetAfterAlreadySelected() {
    this.inputTarget.value = ""
    this.toggleSubmitButtonDisabled()

    if (this.cameraOptionRemovedValue === true) {
      this.removeCameraOption()
    }
  }

}
